import React,  {Component} from 'react'
import help1 from './Assets/Raising.png'
import help2 from './Assets/HappyChildren.png'
import giving from './Assets/Giving.png'
import giving2 from './Assets/Giving2.png'
import giving3 from './Assets/Giving3.png'

import './Home.css'
import Button from '../../components/UI/Button/Button'



class Home extends Component{
    componentDidMount(){
        window.scrollTo(0,0)
    }
    render(){
        return(
            <div className="Home">
                <div className="Landing">
                    <div className="Landing_Left"  data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                        <p> providing sustainable socio- economic development
                            to the most vulnerable individuals and communities
                            globally</p>
                            <Button name="Donate now " clicked={()=>this.props.history.push('/donate')}/>
                    </div>
                    <div className="Landing_Right">

                    </div>
                    <div className="Landing_Mobile">
                        <p className="Landing_Providig">
                            Providing sustainable socio- economic 
                            development to the most vulnerable individuals 
                            and communities globally
                        </p>
                        <Button name="Donate now" clicked={()=>this.props.history.push('/donate')}/>
                    </div>
                </div>
                <div className="Landing2">
                    <div className="Image1" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                        <img src= {help1} />
                    </div>
                    <div className="Welcome" data-aos="fade-up" data-aos-duration="3000">
                        <p className="Home_Welcome">WELCOME TO BLOSSOM AND FLOURISH CARE INITIATIVES</p>
                        <p className="Home_What_We_Do">We are a committed charitable organization that will
                            break the vicious circle of poverty, restore dignity,
                            and provide sustainable socio- economic development to
                            the most vulnerable individuals and communities globally.</p>
                            <Button name="Learn more" clicked={()=>this.props.history.push('/about')}/>
                    </div>
                    <div className="Image2" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                        <img src= {help2} />
                    </div>
                </div>
                <div className="Counts_Video contain">
                    <div className="Counts">
                       <div className="Counter_Row">
                           <div className="Counter">
                               <p className="Count_No">400+</p>
                               <p className="Count_title">LIVES</p>
                           </div>
                           <div className="Counter">
                               <p className="Count_No">500+</p>
                               <p className="Count_title">PROJECTS</p>
                           </div>
                       </div>
                       <div className="Counter_Row">
                           <div className="Counter">
                               <p className="Count_No">50+</p>
                               <p className="Count_title">MEMBERS</p>
                           </div>
                           <div className="Counter">
                               <p className="Count_No">1000+</p>
                               <p className="Count_title">DONATIONS</p>
                           </div>
                       </div>
                    </div>
                </div>
                <div className="Home_Giving">
                    <p className="Giving_The_World">GIVING THE WORLD A VOICE</p>
                    <div className="Givers">
                        <div className="Giving_Contain" data-aos="zoom-out-right">
                            <section className="toMax">
                                <img src={giving} alt="" />
                                <p className="Giving_Name">Science and Technology</p>
                            </section>
                        </div>
                        <div className="Giving_Contain" data-aos="zoom-out">
                            <section className="toMax">
                                <img src={giving2} alt="" />
                                <p className="Giving_Name">Saving of Lives</p>
                            </section>
                        </div>
                        <div className="Giving_Contain" data-aos="zoom-out-left">
                            <section className="toMax">
                                <img src={giving3} alt="" />
                                <p className="Giving_Name">Relief of the Poor</p>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default Home